import React from 'react';
import { Modal, Descriptions } from 'antd';
import moment from 'moment';

const SchoolPopupModal = ({ open, hideModal, school }) => {
  return (
    <Modal
      title="School Information"
      centered
      open={open}
      onOk={hideModal}
      onCancel={hideModal}
      footer={null} // Remove default footer buttons
      width={800}
      className="custom-modal"
    >
      {school ? (
        <Descriptions
          bordered
          column={{ xxl: 2, xl: 2, lg: 2, md: 2, sm: 1, xs: 1 }} // Adjust column layout based on screen size
          layout="horizontal" // Use vertical layout for better readability
        >
          <Descriptions.Item label="UDISE Code">{school.UDISE_Code}</Descriptions.Item>
          <Descriptions.Item label="School Category">{school.School_category}</Descriptions.Item>
          <Descriptions.Item label="School Program">{school.School_program}</Descriptions.Item>
          <Descriptions.Item label="School Name">{school.school_name}</Descriptions.Item>
          <Descriptions.Item label="Principal Name">{school.principal_name}</Descriptions.Item>
          <Descriptions.Item label="Phone Number">{school.phone_no}</Descriptions.Item>
          <Descriptions.Item label="No of Student">{school.no_of_student}</Descriptions.Item>
          <Descriptions.Item label="Classes">{school.classes.join(", ")}</Descriptions.Item>
          <Descriptions.Item label="Trades">{school.trades.join(", ")}</Descriptions.Item>
          <Descriptions.Item label="jobroles">{school.jobroles.join(", ")}</Descriptions.Item>
          <Descriptions.Item label="Address">{school.address}</Descriptions.Item>
          <Descriptions.Item label="District">{school.district}</Descriptions.Item>
          <Descriptions.Item label="State">{school.state}</Descriptions.Item>
          <Descriptions.Item label="State">{school.state}</Descriptions.Item>
          <Descriptions.Item label="Pincode">{school.pincode}</Descriptions.Item>
          <Descriptions.Item label="Created At">{moment(school.createdAt).format('YYYY-MM-DD')}</Descriptions.Item>
        </Descriptions>
      ) : (
        <p>No School data Available.</p>
      )}
    </Modal>
  );
};

export default SchoolPopupModal;
